module.exports = __webpack_public_path__ + "static/img/hills.9e50b678.png";